import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  dropzone: {
    padding: 24,
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    transition: 'border .3s ease-in-out',
    height: '100%',
    textAlign: 'center',
    color: '#192542',
    cursor: 'pointer',
  },
  item: {
    background: '#ffff',
    border: '1px solid #eeeeee',
    wordBreak: 'break-all',
  },
}));
